import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <p>
      <Letop>
        In deze rijtjes zijn alleen de vormen van het praesens indicativus
        volledig uitgeschreven. De andere vormen zijn namelijk dusdanig
        regelmatig, dat de stam leren daarvoor voldoende is.
      </Letop>
    </p>

    <div className="table">
      <table>
        <tbody>
          <tr>
            <th className="col" />
            <th className="no-bor-bot">velle</th>
            <th className="no-bor-bot">nolle</th>
            <th className="no-bor-bot">malle</th>
            <th className="no-bor-bot">ferre</th>
            <th className="no-bor-bot">ire</th>
          </tr>
          <tr>
            <th className="col bor-bot" />
            <th className="no-bold">willen</th>
            <th className="no-bold">niet willen</th>
            <th className="no-bold">liever willen</th>
            <th className="no-bold">(ver)dragen</th>
            <th className="no-bold">gaan</th>
          </tr>
          <tr>
            <th className="col bor-bot" rowSpan={6}>
              prs
            </th>
            <td>volo</td>
            <td>nolo</td>
            <td>malo</td>
            <td>fero</td>
            <td>eo</td>
          </tr>
          <tr>
            <td>vis</td>
            <td>non vis</td>
            <td>mavis</td>
            <td>fers</td>
            <td>is</td>
          </tr>
          <tr>
            <td>vult</td>
            <td>non vult</td>
            <td>mavult</td>
            <td>fert</td>
            <td>it</td>
          </tr>
          <tr>
            <td>volumus</td>
            <td>nolumus</td>
            <td>malumus</td>
            <td>ferimus</td>
            <td>imus</td>
          </tr>
          <tr>
            <td>vultis</td>
            <td>non vultis</td>
            <td>mavultis</td>
            <td>fertis</td>
            <td>itis</td>
          </tr>
          <tr>
            <td className="bor-bot">volunt</td>
            <td className="bor-bot">nolunt</td>
            <td className="bor-bot">malunt</td>
            <td className="bor-bot">ferunt</td>
            <td className="bor-bot">eunt</td>
          </tr>
          <tr>
            <th className="col bor-bot">ipf</th>
            <td className="bor-bot">
              <strong>vole</strong>–ba–m
            </td>
            <td className="bor-bot">
              <strong>nole</strong>–ba–m
            </td>
            <td className="bor-bot">
              <strong>male</strong>–ba–m
            </td>
            <td className="bor-bot">
              <strong>fere</strong>–ba–m
            </td>
            <td className="bor-bot">
              <strong>i</strong>–ba–m
            </td>
          </tr>
          <tr>
            <th className="col bor-bot" rowSpan={3}>
              fut
            </th>
            <td>
              <strong>vol</strong>
              –a–m
            </td>
            <td>
              <strong>nol</strong>
              –a–m
            </td>
            <td>
              <strong>mal</strong>
              -a–m
            </td>
            <td>
              <strong>fer</strong>
              –a–m
            </td>
            <td>
              <strong>i</strong>
              –b–o
            </td>
          </tr>
          <tr>
            <td>
              <strong>vol</strong>
              –e–s
            </td>
            <td>
              <strong>nol</strong>
              –e–s
            </td>
            <td>
              <strong>mal</strong>
              -e–s
            </td>
            <td>
              <strong>fer</strong>
              –e–s
            </td>
            <td>
              <strong>i</strong>
              –b–i–s
            </td>
          </tr>
          <tr>
            <td className="bor-bot">
              <i>enz.</i>
            </td>
            <td className="bor-bot">
              <i>enz.</i>
            </td>
            <td className="bor-bot">
              <i>enz.</i>
            </td>
            <td className="bor-bot">
              <i>enz.</i>
            </td>
            <td className="bor-bot">
              <i>enz.</i>
            </td>
          </tr>
          <tr>
            <th className="col bor-bot">pf</th>
            <td className="bor-bot">
              <strong>volu</strong>
              –i
            </td>
            <td className="bor-bot">
              <strong>nolu</strong>
              –i
            </td>
            <td className="bor-bot">
              <strong>malu</strong>
              –i
            </td>
            <td className="bor-bot">
              <strong>tul</strong>
              –i
            </td>
            <td className="bor-bot">
              <strong>i</strong>
              –i
            </td>
          </tr>
          <tr>
            <th className="col bor-bot">pqp</th>
            <td className="bor-bot">
              <strong>volu</strong>
              –era–m
            </td>
            <td className="bor-bot">
              <strong>nolu</strong>
              –era–m
            </td>
            <td className="bor-bot">
              <strong>malu</strong>
              –era–m
            </td>
            <td className="bor-bot">
              <strong>tul</strong>
              –era–m
            </td>
            <td className="bor-bot">
              <strong>i</strong>
              –era–m
            </td>
          </tr>
          <tr>
            <th className="col bor-bot">fex</th>
            <td className="bor-bot">
              <strong>volu</strong>
              –er–o
            </td>
            <td className="bor-bot">
              <strong>nolu</strong>
              –er–o
            </td>
            <td className="bor-bot">
              <strong>malu</strong>
              –er–o
            </td>
            <td className="bor-bot">
              <strong>tul</strong>
              –er–o
            </td>
            <td className="bor-bot">
              <strong>i</strong>
              –er–o
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/velle-nolle-malle-32.js